export default "__VITE_ASSET__p1h68zWD__"